class DeviceHelper {
  isMobileDevice() {
    const deviceRegex = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
      navigator.userAgent
    );

    const browserRegex =
      /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        navigator.userAgent
      );

    if (deviceRegex) return true;

    if (browserRegex) return true;

    return false;
  }
}

export default new DeviceHelper();
